// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {useHistory} from 'react-router-dom';
import cn from 'classnames';
import styles from './article_card.module.less';
import {Category_badge} from './category_badge';

interface i_article_card_props {
    url: string;
    category?: string | string[];
    title?: string;
    description?: string;
    img?: string;
    author?: string;
    min_read?: number;
    on_category_select?: (category: string)=>void;
}

export const Article_card = (props: i_article_card_props)=>{
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const handle_title_click = ()=>{
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        history.push(props.url);
    };
    return <div className={styles.article_wrapper}
      onClick={handle_title_click}>
      <div className={cn(styles.article_card)}>
        <div className={styles.image_container}>
          {props.img && <img src={props.img} alt={props.title || 'Article'}/>}
        </div>
        <div className={styles.content_container}>
          {props.category &&
            <div className={styles.categories_container}
              onClick={e=>e.stopPropagation()}>
              {(Array.isArray(props.category) ? props.category :
                [props.category]).map((cat, index)=>
                  <Category_badge
                    key={index}
                    category={cat}
                    on_click={props.on_category_select}
                  />
              )}
            </div>
          }
          {props.title &&
            <p className={cn(theme.p16, theme.bold, theme.color_n700,
              styles.title)}>
              {props.title}
            </p>
          }
          {props.description &&
            <p className={cn(theme.p14, theme.med, styles.description)}>
              {props.description}
            </p>
          }
          <div className={styles.meta_container}>
            <p className={cn(theme.p14, theme.med, theme.color_n700,
              styles.author)}>
              {props.author || 'Unknown'}
            </p>
            <span className={styles.dot_container}>
              <span className={styles.dot}></span>
            </span>
            <p className={cn(theme.p12, theme.med, styles.min_read)}>
              {props.min_read || 5} min read
            </p>
          </div>
        </div>
      </div>
    </div>;
};
